import React, { useEffect, useState } from "react";
import UseGeneral from "../../hooks/useGeneral";
import { MdOutlineMailOutline } from "react-icons/md";
import { Axios } from "../../Axios";
import { CiLocationOn } from "react-icons/ci";
import { BASE_URL } from "../../Axios/base_url";
import './contactus.css';
import axios from "axios";
import { FaPhoneFlip } from "react-icons/fa6";
import Brands from "../../layouts/home/brands";
import { ThreeDots } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
const ContactUs = () => {
  const { language } = UseGeneral();
  const siteData = useSelector((state) => state?.site?.siteData);

  const [contactData, setContactData] = useState({
    name: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [brands, setBrands] = useState([]);
  const [addLoading, setAddLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  // const getSiteInfo=()=>{
  //   setPageLoading(true)
  //   axios.get(BASE_URL+'site_info/get_all_for_user')
  //   .then((res)=>{
  //     setSiteData({
  //       site_location:res?.data?.result?.site_location,
  //       phone:res?.data?.result?.phone,
  //       email:res?.data?.result?.email,
  //     })
  //   }).catch(e=>console.log(e)).finally(()=>{
  //     setPageLoading(false)
  //   })
  // }
  const getBrands = () => {
    axios
      .get(BASE_URL + 'brands/get_all')
      .then((res) => {
        setBrands(res.data.result);
      })
      .catch((e) => console.log(e));
  };

  const addMessage = () => {
    if (contactData.name == '') {
      toast.error(language == 'ar' ? 'الإسم مطلوب' : 'Name is Required');
      return;
    }
    if (contactData.subject == '') {
      toast.error(language == 'ar' ? 'الموضوع مطلوب' : 'Subject is Required');
      return;
    }
    if (contactData.phone == '') {
      toast.error(language == 'ar' ? 'رقم الهاتف مطلوب' : 'Phone is Required');
      return;
    }
    if (contactData.message == '') {
      toast.error(language == 'ar' ? 'الرساله مطلوب' : 'Message is Required');
      return;
    }
    setAddLoading(true);
    const data_send = {
      ...contactData,
    };
    // let lang=language;
    ;
    axios
      .post(BASE_URL + 'user_messages/add_new_message', data_send, {
        headers: {
          lang: language,
        },
      })
      .then((res) => {
        ;
        if (res.data.status == 'success') {
          toast.success(res.data.message);
          setContactData({
            name: '',
            phone: '',
            subject: '',
            message: '',
          });
        } else if (res.data.status == 'error') {
          toast.error(res.data.message);
        } else {
          toast.error(language == 'ar' ? 'حدث خطأ ما' : 'Something Went Error');
        }
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          ;
          ;
          ;
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          ;
        } else {
          // Something happened in setting up the request that triggered an Error
          ;
        }
        ;
      })
      .finally(() => {
        setAddLoading(false);
      });
  };

  useEffect(() => {
    // getSiteInfo();
    getBrands();
  }, []);

  return (
    <div className="contact_page">
      <div className="map"></div>
      <div className="cont_form">
        <div className="contact_form">
          <h5>{language == 'ar' ? 'ابقى على تواصل' : 'keep in touch'}</h5>
          <p>{language == 'ar' ? ' اترك لنا رسالة ' : 'Leave us a message'}</p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              addMessage();
            }}
            action=""
          >
            <div className="row row-gap-2">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <label htmlFor="">{language == 'ar' ? 'الإسم' : 'Name'}:</label>
                <input
                  value={contactData.name}
                  onChange={(e) => {
                    setContactData({
                      ...contactData,
                      name: e.target.value,
                    });
                  }}
                  type="text"
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <label htmlFor="">
                  {language == 'ar' ? 'رقم الهاتف' : 'Phone Number'}:
                </label>
                <input
                  value={contactData.phone}
                  onChange={(e) => {
                    setContactData({
                      ...contactData,
                      phone: e.target.value,
                    });
                  }}
                  type="text"
                />
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12">
                <label htmlFor="">
                  {language == 'ar' ? 'الموضوع' : 'Subject'}:
                </label>
                <input
                  value={contactData.subject}
                  onChange={(e) => {
                    setContactData({
                      ...contactData,
                      subject: e.target.value,
                    });
                  }}
                  type="text"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <label htmlFor="">
                  {language == 'ar' ? 'رسالتك' : 'Your Message'}:
                </label>
                <textarea
                  value={contactData.message}
                  onChange={(e) => {
                    setContactData({
                      ...contactData,
                      message: e.target.value,
                    });
                  }}
                  name=""
                  id=""
                  cols="30"
                  rows="10"
                ></textarea>
              </div>
            </div>
            {addLoading ? (
              <ThreeDots />
            ) : (
              <button>{language == 'ar' ? 'إرسال' : 'Send'}</button>
            )}
          </form>
        </div>
        <div className="site_data">
          <div
            className=""
            style={{ cursor: "pointer" }}
            onClick={() => window.open("mailto:" + siteData.email, "_blanck")}
          >
            <MdOutlineMailOutline />
            <h5>{siteData.email}</h5>
          </div>
          <div className="">
            <CiLocationOn />
            <h5>{siteData.site_location}</h5>
          </div>
          <div
            className=""
            style={{ cursor: "pointer" }}
            onClick={() => window.open("tel:" + siteData.phone, "_blanck")}
          >
            <FaPhoneFlip />
            <h5>{siteData.phone}</h5>
          </div>
        </div>
      </div>
      <Brands brands={brands} />
    </div>
  );
};

export default ContactUs;
